var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('SdsCarousel',{staticClass:"promotions-banner-carousel",attrs:{"items":_vm.bannerSlides,"title":"","layoutVariant":"auto","layoutValue":320,"customizeBaseOptions":{
        expandOnlyItem: false,
        mobileOptions: {
            expandOnlyItem: false,
        }
    }},scopedSlots:_vm._u([{key:"default",fn:function(ref){
    var data = ref.data;
    var index = ref.index;
return [_c('SdsBannerPromo',{attrs:{"banner":data,"seoHref":_vm.resolveHrefForSeo(data)},on:{"click":function($event){return _vm.openLink(data, index)}}})]}}])})}
var staticRenderFns = []

export { render, staticRenderFns }